"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./slider.css");
var _hammerjs = _interopRequireDefault(require("@egjs/hammerjs"));
var _popmotion = require("popmotion");
var _circularSlideStyle = require("./slide-styles/circular-slide-style");
var _slideStyle = require("./slide-styles/slide-style");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
var classNames = require("classnames");
var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits(Slider, _React$Component);
  var _super = _createSuper(Slider);
  function Slider(props) {
    var _this;
    _classCallCheck(this, Slider);
    _this = _super.call(this, props);
    _this.initialPaddingCount = 1;
    if (props.paddingCount) {
      _this.initialPaddingCount = props.paddingCount;
    }
    _this.shownSlides = props.shownSlides || 3;
    _this.state = {
      activeSlide: 0,
      offset: 0,
      slideOffset: 0,
      paddingCount: _this.initialPaddingCount,
      dragging: false,
      width: 1,
      documentWidth: 1
    };
    _this.animationDuration = props.animationDuration;
    _this.shownSlides = props.shownSlides || 3;
    _this.children = _react["default"].Children.toArray(_this.props.children);
    _this.originalLength = _this.children.length;
    _this.repeatedTimes = 0;
    var c = [];
    if (_this.children.length <= 1) {
      c.push.apply(c, _toConsumableArray(_this.children));
    } else {
      for (var i = 0; i < _this.shownSlides * 4; i += _this.children.length) {
        c.push.apply(c, _toConsumableArray(_this.children));
        _this.repeatedTimes++;
      }
    }
    _this.hammerContainerRef = /*#__PURE__*/_react["default"].createRef();
    _this.children = c;
    _this.length = _this.children.length;
    _this.slideStyle = _this.props.slideStyle || new _circularSlideStyle.CircularSlideStyle();
    _this.slideStyle.setLength(_this.length);
    return _this;
  }
  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.resizeListener = function () {
        return _this2.handleResize();
      };
      window.addEventListener("resize", this.resizeListener, {
        passive: true
      });
      this.createInterval();
      this.handleResize();
      if (this.hammerContainerRef.current) {
        var mc = new _hammerjs["default"](this.hammerContainerRef.current, {
          recognizers: [
          // [
          //     Hammer.Pan,
          //     {event: 'panv', direction: Hammer.DIRECTION_VERTICAL}
          // ],
          [_hammerjs["default"].Pan,
          // RecognizerClass
          {
            direction: _hammerjs["default"].DIRECTION_HORIZONTAL,
            threshold: 10
          } // options
          // ['swipe'],                                // recognizeWith
          // ['panvertical']                           // requireFailure
          ]]
        });

        mc.on("panleft panright", function (e) {
          _this2.handlePan(e);
        });
        mc.on("panend", function (e) {
          _this2.handlePanEnd(e);
        });
        mc.on("pancancel", function (e) {
          _this2.handlePanCancel(e);
        });
      }
      if (this.props.onMount) {
        this.props.onMount({
          slideBy: function slideBy(offset) {
            var hasInterval = !!_this2.interval;
            if (hasInterval) {
              _this2.stopInterval();
            }
            _this2.slideBy(offset);
            if (hasInterval) {
              _this2.createInterval();
            }
          },
          goToIndex: function goToIndex(index) {
            var hasInterval = !!_this2.interval;
            if (hasInterval) {
              _this2.stopInterval();
            }
            _this2.goTo(index);
            if (hasInterval) {
              _this2.createInterval();
            }
          },
          pauseInterval: function pauseInterval() {
            return _this2.stopInterval();
          },
          startInterval: function startInterval() {
            return _this2.createInterval();
          }
        });
      }
    }
  }, {
    key: "createInterval",
    value: function createInterval() {
      var _this3 = this;
      if (this.props.interval && !this.interval) {
        this.interval = setInterval(function () {
          !document.hidden && _this3.slideBy(1);
        }, this.props.interval);
      }
    }
  }, {
    key: "stopInterval",
    value: function stopInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("resize", this.resizeListener);
      this.stopInterval();
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      this.width = this.sliderRef.getBoundingClientRect().width;
      this.documentWidth = document.body.offsetWidth;
      this.slideStyle.setWidth(this.width);
      this.slideStyle.setDocumentWidth(this.documentWidth);
      this.setState({
        width: this.width,
        documentWidth: this.documentWidth
      });
    }
  }, {
    key: "handlePan",
    value: function handlePan(ev) {
      if (ev.isFinal) {
        return;
      }
      this.stopInterval();
      var deltaX = this.slideStyle.getSwipeDelta(ev.deltaX);
      this.setState({
        offset: this.state.activeSlide * this.width - deltaX,
        dragging: true
      });
    }
  }, {
    key: "handlePanEnd",
    value: function handlePanEnd(ev) {
      var deltaX = this.slideStyle.getSwipeDelta(ev.deltaX);
      this.setState({
        dragging: false
      });
      var staticOffset = -deltaX / this.width;
      var velocity = Math.abs(ev.velocityX) > .5 ? -Math.min(2, Math.max(-2, ev.overallVelocityX / 2)) : 0;
      this.slideBy(Math.round(staticOffset + velocity));
      this.createInterval();
    }
  }, {
    key: "handlePanCancel",
    value: function handlePanCancel(ev) {
      this.setState({
        dragging: false
      });
      this.slideBy(0);
      this.createInterval();
    }
  }, {
    key: "goTo",
    value: function goTo(index) {
      if (index < 0) {
        console.error('index ' + index + ' is not a valid index for @fp/react-slider.');
        return;
      }
      var targetOffset = index % this.originalLength - this.state.activeSlide % this.originalLength;
      if (targetOffset > this.originalLength / 2) {
        this.slideBy(-this.originalLength + targetOffset);
      } else if (targetOffset < this.originalLength / -2) {
        this.slideBy(this.originalLength + targetOffset);
      } else {
        this.slideBy(targetOffset);
      }
    }
  }, {
    key: "slideBy",
    value: function slideBy(offset) {
      var _this4 = this;
      var velocity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var activeSlide = (this.state.activeSlide + offset + this.length) % this.length;
      var draggedOffset = this.state.activeSlide * this.width - this.state.offset;
      this.setState({
        dragging: false,
        activeSlide: activeSlide
      });
      this.panValue = (0, _popmotion.value)((activeSlide - offset) * this.width - draggedOffset, function (val) {
        _this4.setState({
          offset: val
        });
      });
      (0, _popmotion.tween)({
        from: (activeSlide - offset) * this.width - draggedOffset,
        to: activeSlide * this.width,
        duration: this.animationDuration
      }).start(this.panValue);
      if (this.props.onSlideChange) {
        this.props.onSlideChange(activeSlide % this.props.children.length);
      }
    }
  }, {
    key: "getSlideStyle",
    value: function getSlideStyle(index, offset) {
      return this.slideStyle.getSlideStyle(index, offset);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classNames("_fp-slider", {
          not_dragging: !this.state.dragging
        }),
        ref: function ref(_ref) {
          return _this5.sliderRef = _ref;
        }
      }, this.originalLength > 1 ? /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.hammerContainerRef
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "_fp-slider--container"
      }, this.children.map(function (el, index) {
        var style = _this5.getSlideStyle(index, _this5.state.offset); // this uses style in the key to rerender the given element if the style changes during resize

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "_fp-slider--slide",
          key: "slide_" + index + style,
          style: style
        }, el);
      }))) : /*#__PURE__*/_react["default"].createElement("div", {
        className: "_fp-slider--container"
      }, this.children.map(function (el, index) {
        var style = _this5.getSlideStyle(index, 0); // this uses style in the key to rerender the given element if the style changes during resize

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "_fp-slider--slide",
          key: "slide_" + index + style,
          style: style
        }, el);
      })));
    }
  }]);
  return Slider;
}(_react["default"].Component);
Slider.defaultProps = {
  animationDuration: 300
};
Slider.propTypes = {
  onMount: _propTypes["default"].func,
  onSlideChange: _propTypes["default"].func,
  interval: _propTypes["default"].number,
  animationDuration: _propTypes["default"].number,
  slideStyle: _propTypes["default"].instanceOf(_slideStyle.SlideStyle)
};
var _default = Slider;
exports["default"] = _default;